import * as ActionTypes from "../action-types/style";

export const setLoadingGeneral = () => {
  return {
    type: ActionTypes.SET_LOADING_GENERAL,
  };
};

export const unsetLoadingGeneral = () => {
  return {
    type: ActionTypes.UNSET_LOADING_GENERAL,
  };
};

export const setLoadingApplication = () => {
  return {
    type: ActionTypes.SET_LOADING_APPLICATION,
  };
};
export const unsetLoadingApplication = () => {
  return {
    type: ActionTypes.UNSET_LOADING_APPLICATION,
  };
};

export const setLoadingBilling = () => {
  return {
    type: ActionTypes.SET_LOADING_BILLING,
  };
};
export const unsetLoadingBilling = () => {
  return {
    type: ActionTypes.UNSET_LOADING_BILLING,
  };
};

export const setLoadingEmployee = () => {
  return {
    type: ActionTypes.SET_LOADING_EMPLOYEE,
  };
};
export const unsetLoadingEmployee = () => {
  return {
    type: ActionTypes.UNSET_LOADING_EMPLOYEE,
  };
};

export const setLoadingEmployer = () => {
  return {
    type: ActionTypes.SET_LOADING_EMPLOYER,
  };
};
export const unsetLoadingEmployer = () => {
  return {
    type: ActionTypes.UNSET_LOADING_EMPLOYER,
  };
};

export const setLoadingRemark = () => {
  return {
    type: ActionTypes.SET_LOADING_REMARK,
  };
};
export const unsetLoadingRemark = () => {
  return {
    type: ActionTypes.UNSET_LOADING_REMARK,
  };
};

export const setLoadingGroup = () => {
  return {
    type: ActionTypes.SET_LOADING_GROUP,
  };
};

export const unsetLoadingGroup = () => {
  return {
    type: ActionTypes.UNSET_LOADING_GROUP,
  };
};

export const setLoadingPayroll = () => {
  return {
    type: ActionTypes.SET_LOADING_PAYROLL,
  };
};

export const unsetLoadingPayroll = () => {
  return {
    type: ActionTypes.UNSET_LOADING_PAYROLL,
  };
};

export const setLoadingCompany = () => {
  return {
    type: ActionTypes.SET_LOADING_COMPANY,
  };
};

export const unsetLoadingCompany = () => {
  return {
    type: ActionTypes.UNSET_LOADING_COMPANY,
  };
};

export const setLoadingDashboardAll = () => {
  return {
    type: ActionTypes.SET_LOADING_DASHBOARD_ALL,
  };
};

export const unsetLoadingDashboardAll = () => {
  return {
    type: ActionTypes.UNSET_LOADING_DASHBOARD_ALL,
  };
};

export const setLoadingDashboardDaily = () => {
  return {
    type: ActionTypes.SET_LOADING_DASHBOARD_DAILY,
  };
};

export const unsetLoadingDashboardDaily = () => {
  return {
    type: ActionTypes.UNSET_LOADING_DASHBOARD_DAILY,
  };
};

export const setLoadingDashboardMonthly = () => {
  return {
    type: ActionTypes.SET_LOADING_DASHBOARD_MONTHLY,
  };
};

export const unsetLoadingDashboardMonthly = () => {
  return {
    type: ActionTypes.UNSET_LOADING_DASHBOARD_MONTHLY,
  };
};